import * as Yup from "yup";

export const faqValidationSchema = Yup.object().shape({
  category_id: Yup.string().trim().required("Category is required"),
  question: Yup.string().trim().required("Question by is required"),
  answer: Yup.string()
    .trim()
    .required("Answer is required")
    .max(500, "Answer cannot exceed 500 characters"),
});

export const faqCatValidationSchema = Yup.object().shape({
  title: Yup.string().trim().required("Category is required"),
});
